/* eslint-disable react/sort-comp */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Icon from 'react-native-vector-icons/FontAwesome';
import { t } from 'Locale';
import { View } from 'react-native';
import Theme from 'Theme/index';
import CategoriesFilterPage from './Pages/CategoriesFilterPage';
import ListFilterPage from './Pages/ListFilterPage';
import { FilterPagesEnum } from './Pages';

const styles = {
    togglerContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgba(38, 38, 38, 0.8)',
        width: 144,
        height: 48,
        zIndex: 99,
        borderWidth: 0,
        paddingLeft: 24,
        justifyContent: 'space-between',
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.5)'
    },
    menuContainer: {
        position: 'absolute',
        paddingLeft: 12,
        paddingRight: 12,
        top: 49,
        left: 0,
        width: 360,
        height: 490,
        backgroundColor: 'rgba(255,255,255, 0.98)',
        zIndex: 99,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
    },
    defaultFont: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        letterSpacing: 0.7
    },
    trashIcon: {
        width: 15.5,
        height: 17.25,
        marginRight: 8.25
    },
    resetButton: {
        backgroundColor: '#00a2de',
        padding: 15,
        color: '#fff',
        border: 'none',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

const WebFilter = ({
    categories,
    onCheckFilter,
    filterIsUsed,
    theme,
    toggleFilters,
    listMode,
    onListModeSelected,
    allChannels,
    liveChannels,
    favoriteChannels,
    onReset,
    hideChannelListTypeAll
}) => {
    const [page, setPage] = useState(FilterPagesEnum.LIST);
    const [displayFilterMenu, setDisplayFilterMenu] = useState(false);

    const onOpenCategories = async (selectedListMode) => {
        if (selectedListMode !== listMode) {
            await onListModeSelected(selectedListMode);
        }

        setPage(FilterPagesEnum.CATEGORIES);
    };

    const onToggleFilters = useCallback(() => {
        toggleFilters();
        setPage(FilterPagesEnum.LIST);
    }, [toggleFilters]);

    const onFilterClose = () => {
        onToggleFilters();
        setDisplayFilterMenu(!displayFilterMenu);
    };

    return (
        <>
            <button
                type="button"
                style={{
                    color:  displayFilterMenu || filterIsUsed || listMode === 'favorites' ? '#00a0de' : '#ebebeb',
                    ...styles.togglerContainer,
                    ...styles.defaultFont
                }}
                onClick={() => setDisplayFilterMenu(!displayFilterMenu)}
            >
                {t('COMMON.FILTER')}
                {displayFilterMenu ? (
                    <Icon
                        style={{ marginRight: 20 }}
                        name="caret-up"
                        size={25}
                        color={
                            displayFilterMenu || filterIsUsed
                                ? Theme.activeColor
                                : Theme.primaryTextColor
                        }
                    />
                ) : (
                    <Icon
                        style={{ marginRight: 20 }}
                        name="caret-down"
                        size={25}
                        color={
                                displayFilterMenu || filterIsUsed || listMode === 'favorites'
                                ? Theme.activeColor
                                : Theme.primaryTextColor
                        }
                    />
                )}
            </button>

            {displayFilterMenu && (
                <div style={{ ...styles.menuContainer }}>
                    <View style={[theme.window.container, { flex: 1 }]}>
                        {page === FilterPagesEnum.CATEGORIES ? (
                            <CategoriesFilterPage
                                theme={theme}
                                categories={categories}
                                onClose={onFilterClose}
                                onBack={() => {
                                    setPage(FilterPagesEnum.LIST);
                                }}
                                onSelected={onCheckFilter}
                                onReset={onReset}
                                listMode={listMode}
                            />
                        ) : (
                            <ListFilterPage
                                heading={t('COMMON.FILTER_BY_CHANNELS')}
                                listMode={listMode}
                                theme={theme}
                                onClose={onFilterClose}
                                onSelected={onListModeSelected}
                                onBack={() => {
                                    setPage(FilterPagesEnum.CATEGORIES);
                                }}
                                openCategories={onOpenCategories}
                                allChannels={allChannels}
                                liveChannels={liveChannels}
                                favoriteChannels={favoriteChannels}
                                onReset={onReset}
                                hideChannelListTypeAll={hideChannelListTypeAll}
                            />
                        )}
                    </View>
                </div>
            )}
        </>
    );
};

WebFilter.defaultProps = {
    hideChannelListTypeAll: false
};

WebFilter.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onCheckFilter: PropTypes.func.isRequired,
    theme: PropTypes.shape({}).isRequired,
    toggleFilters: PropTypes.func.isRequired,
    listMode: PropTypes.string.isRequired,
    onListModeSelected: PropTypes.func.isRequired,
    allChannels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    liveChannels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    favoriteChannels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onReset: PropTypes.func.isRequired,
    hideChannelListTypeAll: PropTypes.bool,
    filterIsUsed: PropTypes.bool.isRequired
};

export default WebFilter;
